import { Button, Modal } from "@mui/material";
import React from "react";
import { useState } from "react";
import { BsYoutube } from "react-icons/bs";
import ReactPlayer from "react-player";
import { ReactComponent as VideoPlayerSVG } from "../assets/img/play.svg";
import PlayButton from "../portals/customer/assets/play.png";
import Thumbnail from "../portals/customer/assets/thumb.png"

export const VideoPlayModal = ({
  videoUrl,
  notFound,
  color,
  newPlayButton,
  onboarding
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(!open);
  };
  return (
    <>
      {notFound ? (
        <Button
          onClick={handleOpen}
          sx={{
            "&.MuiButtonBase-root": {
              border: "1px solid #8D40FF",
              color: color || "#8D40FF",
            },
          }}
          variant="outlined"
          startIcon={<BsYoutube size={20} color={color || "#8D40FF"} />}
        >
          Watch Video
        </Button>
      ) : newPlayButton ? (
        <div
          onClick={handleOpen}
          style={{
            background: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "270px",
            borderRadius: "10px",
          }}
        >
          <img
            src={PlayButton}
            alt="playButton"
            style={{ cursor: "pointer" }}
          />
        </div>
      ) : onboarding ? (
        <div style={{ position: "relative" }}>
          <img src={Thumbnail} style={{ width: "100%" }} />
          <div
            style={{
              background: "rgba(0,0,0,0.6)",
              position: "absolute",
              top: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <div  onClick={handleOpen}>
            <img
            src={PlayButton}
            alt="playButton"
            style={{
              marginTop: "100px",
              cursor: "pointer",
            }}
          />
            </div>
          </div>
          {/* <VideoPlayModal newPlayButton={true} videoUrl={videoUrl} /> */}
        </div>
      ) : (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={handleOpen}
        >
          {/* <BsYoutube size={24} color={color || "#8D40FF"} /> */}
          <VideoPlayerSVG style={{ width: "20px", height: "20px" }} />
        </div>
      )}

      <Modal
        sx={{
          ".MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, .7) !important",
            border: "none !important",
          },
        }}
        open={open}
        onClose={() => setOpen(!open)}
      >
        <div
          style={{
            outline: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            Width: "55%",
            Height: "600px",
            textAlign: "center",
            bgcolor: "background.paper",
            boxShadow: 24,
            overflow: "hidden",
          }}
          className="hide_scrollbar"
        >
          <ReactPlayer
            url={videoUrl}
            controls={true}
            width="100%"
            height="100%"
            playing="true"
          />

          {/* <button
            onClick={handleVideoToggle}
            style={{ position: "absolute", bottom: "15px", right: "10px" }}
          >
            {isPlaying ? "Pause" : "Play"}
          </button> */}
        </div>
      </Modal>
    </>
  );
};
